import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "../../app/store";
import { resetLogs, setOffset } from "./errorLogsSlice";
import { obsApi } from "api";

interface FetchErrorArgs {
  limit?: number;
  startTime?: number;
  endTime?: number;
}

export const fetchErrorLogs = createAsyncThunk(
  "errorLog/fetchErrorLogs",
  async (args: FetchErrorArgs, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const filters = state.error.filters;
    const query = state.error.query;
    const startTime = state.error.currentTime;
    return obsApi.error
      .searchError({
        limit: args.limit,
        start_time: startTime,
        filters: filters,
        query: query,
      })
      .then((res) => {
        if (res.data !== undefined) {
          return res.data;
        }
      })
      .catch((err) => {
        return rejectWithValue(err);
      });
  },
);

export const fetchNextPage = (): AppThunk => (dispatch, getState) => {
  const state = getState() as RootState;
  const { offset, resultsPerPage } = state.error;

  dispatch(setOffset(offset + resultsPerPage));
  dispatch(fetchErrorLogs({}));
};
export const reloadLogs = (): AppThunk => (dispatch) => {
  dispatch(setOffset(0));
  dispatch(resetLogs());
  dispatch(fetchErrorLogs({}));
};
